import {
  createContext,
  useContext,
  type ReactNode,
} from "react";
import type { ClientesGateway } from "../infrastructure/clientes.gateway";

const Contexto = createContext<ClientesGateway | null>(null);

export function ProvedorDeClientes({
  gateway,
  children,
}: {
  readonly gateway: ClientesGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useClientesGateway(): ClientesGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error("useClientesGateway fora do ProvedorDeClientes");
  }
  return gateway;
}
